import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { createAuth, getAuth, resetStatus } from "../../features/auth/authSlice";
import { AuthData, NewAuthData } from "../../types/api/authApi";
import { toast } from "react-toastify";
import { useAppDispatch, useAppSelector, useAuth } from "../../Hooks";


const Login: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [activeForm, setActiveForm] = useState<Boolean>(true); //true=>login false=>signup
    const [registrationFormData, setRegistrationFormData] = useState<NewAuthData>({ name: "", email: "", password: "" });
    const [logInFormData, setLogInFormData] = useState<AuthData>({ email: "user@yopmail.com", password: "Test@123" });
    const [passwordVisible, setPasswordVisible] = useState<Boolean>(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const { login } = useAuth();


    const { user, status, msg } = useAppSelector(state => state.auth);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        if (activeForm) {
            setLogInFormData({
                ...logInFormData,
                [name]: value,
            });
        } else {
            setRegistrationFormData({
                ...registrationFormData,
                [name]: value,
            });
        }
    }

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (activeForm) {
            dispatch(getAuth(logInFormData));
        } else {
            dispatch(createAuth(registrationFormData));
        }
    }

    useEffect(() => {
        // const token = localStorage.getItem('token')
        if (status) {
            // login(user);

            // navigate(`/${user.role}/dashboard`);
            navigate(`/`);


            toast.success(msg);
            dispatch(resetStatus())
        }

    }, [status, user, login, navigate, msg, dispatch])



    return (
        <div>
            <section className="banner login-banner">
                <div className="overlay"></div>
                <div className="container">
                    <div className="login">
                        <div className="login-form">
                            <div className="login-heading">
                                <img src={require('../../assets/images/logo.png')} alt="logo" className="img-fluid" />
                                <p>{activeForm ? "Login Your Account" : "Sign Up in Your Account"}</p>
                            </div>
                            <form className="form-content" onSubmit={handleSubmit}>
                                <Row>
                                    {
                                        !activeForm && <Col md={12}>
                                            <div className="form-group">
                                                <label htmlFor="name">Name</label>
                                                <input type="text" placeholder="Enter Your Name" id="name" name="name" onChange={handleInputChange} />
                                            </div>
                                        </Col>
                                    }

                                    <Col md={12}>
                                        <div className="form-group">
                                            <label htmlFor="mail">Email</label>
                                            <input type="email" placeholder="hello@example.com" id="email" name="email" onChange={handleInputChange} />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="form-group">
                                            <label htmlFor="password">Password</label>
                                            <div className="password-wrapper">
                                                <input
                                                    type={passwordVisible ? "text" : "password"}
                                                    placeholder="....."
                                                    id="password"
                                                    name="password"
                                                    onChange={handleInputChange}
                                                />
                                                <span onClick={togglePasswordVisibility} className="field-icon">
                                                    <i className={passwordVisible ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    {
                                        !activeForm && <Col md={12}>
                                            <div className="form-group">
                                                <label htmlFor="name">Name</label>
                                                <input type="text" placeholder="Enter Your Name" id="name" name="name" onChange={handleInputChange} />
                                            </div>
                                        </Col>
                                    }
                                    {
                                        activeForm &&
                                        <>
                                            <Col md={6}>
                                                <div className="form-group form-checkbox">
                                                    <input type="checkbox" id="remember" name="remember" />
                                                    <label htmlFor="remember">Remember Me</label>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="form-group text-md-end">
                                                    <Link to="/forgot-password" className="forgot-password">Forgot Password?</Link>
                                                </div>
                                            </Col>
                                        </>
                                    }
                                    <Col md={12}>
                                        <div className="form-group">
                                            <button type="submit" className="btn-gold submit-btn">
                                                {activeForm ? "Login" : "Signup"}
                                                <i className="bi bi-box-arrow-right"></i>
                                            </button>
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        {activeForm ?
                                            <p className="signin-text text-center">
                                                Don't have an account?
                                                <Link to="#" onClick={() => setActiveForm(!activeForm)}>Sign up</Link>
                                            </p>
                                            :
                                            <p className="signin-text text-center">
                                                Already have an account?
                                                <Link to="#" onClick={() => setActiveForm(!activeForm)}>Sign in</Link>
                                            </p>
                                        }
                                    </Col>
                                </Row>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Login;
